const initSdProductCarousels = (scope = document) => {
  scope.querySelectorAll('[data-sd-carousel]').forEach((carousel) => {
    if (carousel.dataset.sdCarouselReady === 'true') return;
    carousel.dataset.sdCarouselReady = 'true';
    const track = carousel.querySelector('.sd-product-track');
    carousel.querySelector('[data-sd-prev]')?.addEventListener('click', () => track?.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }));
    carousel.querySelector('[data-sd-next]')?.addEventListener('click', () => track?.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }));
  });
};

const initSdHeroCarousels = (scope = document) => {
  scope.querySelectorAll('[data-sd-hero-carousel]').forEach((carousel) => {
    if (carousel.dataset.sdHeroReady === 'true') return;
    carousel.dataset.sdHeroReady = 'true';
    const slides = [...carousel.querySelectorAll('.sd-hero__slide')];
    const dots = [...carousel.querySelectorAll('[data-sd-hero-dot]')];
    if (!slides.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = carousel.dataset.autoplay === 'true' && !reduceMotion && slides.length > 1;
    const interval = Math.max(Number(carousel.dataset.interval) || 5000, 3000);
    let current = 0;
    let timer;
    let changeRequest = 0;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    };
    carousel.sdHeroShow = show;
    const prepare = (index) => {
      const next = (index + slides.length) % slides.length;
      const images = [...slides[next].querySelectorAll('img')];
      images.forEach((image) => { image.loading = 'eager'; });
      return Promise.all(images.map((image) => {
        if (image.complete && image.naturalWidth > 0) return Promise.resolve();
        return image.decode?.().catch(() => undefined) || Promise.resolve();
      }));
    };
    const stop = () => {
      window.clearTimeout(timer);
      timer = undefined;
    };
    const start = () => {
      stop();
      if (autoplay) timer = window.setTimeout(async () => {
        const next = current + 1;
        const request = ++changeRequest;
        await prepare(next);
        if (request !== changeRequest) return;
        show(next);
        start();
      }, interval);
    };

    dots.forEach((dot, index) => dot.addEventListener('click', async () => {
      stop();
      const request = ++changeRequest;
      await prepare(index);
      if (request !== changeRequest) return;
      show(index);
      start();
    }));
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0);
    prepare(1);
    start();
  });
};

initSdProductCarousels();
initSdHeroCarousels();
document.addEventListener('shopify:section:load', (event) => {
  initSdProductCarousels(event.target);
  initSdHeroCarousels(event.target);
});
document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.closest('.sd-hero__slide');
  if (!slide) return;
  const carousel = slide.closest('[data-sd-hero-carousel]');
  const slides = [...carousel.querySelectorAll('.sd-hero__slide')];
  const selectedIndex = slides.indexOf(slide);
  if (selectedIndex >= 0 && typeof carousel.sdHeroShow === 'function') carousel.sdHeroShow(selectedIndex);
});
